module.exports = __webpack_public_path__ + "static/media/original.00373dff.jpeg";